/*
 * Frontend Javascript
 *
 * All of your custom javascript can be placed below, remember to seperate your functionality into seperate files.
 * Do NOT forgot to add comments above the different functions or functionalities that need explaining.
 *
 */
require('./bootstrap');

var components = './components/';
var utilities = './utilities/';

// Load all components below, for example:
// require(components + 'your-file');
require(components + 'prepare_for_ajax');

// require(utilities + 'your-file');
require(utilities + 'breakpoint-size.js');
require(utilities + 'window-width.js');



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/app.js